import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Mail } from "lucide-react";
import Logo from "@/components/Logo";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-10 bg-white">
      <div className="w-full max-w-sm">
        <Link to="/login" className="inline-flex items-center text-sm text-dapnow-muted hover:text-dapnow-ink mb-6">
          <ArrowLeft className="h-4 w-4 mr-1" /> Torna al login
        </Link>
        <Logo />
        <p className="overline mt-6">Recupero password</p>
        <h1 className="font-display text-3xl font-extrabold tracking-tighter mt-1">Hai dimenticato la password?</h1>

        {done ? (
          <div className="mt-6 rounded-2xl border border-emerald-200 bg-emerald-50 p-5" data-testid="forgot-password-success">
            <Mail className="h-5 w-5 text-emerald-700" />
            <p className="mt-2 font-semibold text-emerald-900">Controlla la tua email</p>
            <p className="text-sm text-emerald-900/80 mt-1">
              Se l'email è registrata, abbiamo inviato un link per impostare una nuova password. Il link è valido per 1 ora.
            </p>
            <p className="text-xs text-emerald-900/70 mt-3">
              Non ricevi l'email? Controlla in spam, oppure <Link to="/forgot-password" className="font-semibold underline">riprova</Link>.
            </p>
          </div>
        ) : (
          <>
            <p className="text-sm text-dapnow-muted mt-2">
              Inserisci la tua email: ti invieremo un link per reimpostare la password.
            </p>
            <form onSubmit={onSubmit} className="mt-6 space-y-4">
              <div>
                <label className="text-sm font-semibold tracking-tight">Email</label>
                <input
                  type="email"
                  required
                  data-testid="forgot-email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input-tall mt-1.5 w-full"
                  placeholder="tu@email.ch"
                />
              </div>
              <button
                type="submit"
                disabled={submitting}
                data-testid="forgot-submit-btn"
                className="btn-primary w-full"
              >
                {submitting ? "Invio…" : "Invia link di reset"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
